import * as util from '@/lib/util';
import { validateMessage } from '@/lib/validation';

export default {
  data() {
    return {
      pickerMixin_data: {
        /**
         * time picker の規定値
         */
        pickerOption: {
          start: '00:00',
          step: '00:30',
          end: '23:30',
        },
        /**
         * 計測期間開始日用の設定
         * @returns {Object}
         */
        datePickerOptionsStart: {
          /**
           * 日付のdisabled処理
           * 開始日は設定日から現在日または終了日時まで選択可能にする
           * @param {date} date - 表示する日付のdateオブジェクト
           * @returns {function}
           */
          disabledDate: (date) => {
            /**
             * 現在日より未来ならtrue 同日or過去ならfalse
             * @returns {boolean}
             */
            const condition1 = date.getTime() > Date.now();
            /**
             * @returns {number} unixtime
             */
            const str = this.datetimeSet.dateEnd;
            const replaced = str.replace(/-/g, ' ,');
            const dateTime = new Date(replaced).getTime();
            /**
             * 終了日より未来ならtrue 同日or過去ならfalse
             * @returns {boolean}
             */
            const condition2 = date.getTime() > dateTime;
            // いずれかがtrueならdisabledにする
            return condition1 || condition2;
          },
        },
        /**
         * 計測期間終了日用の設定
         * @returns {Object}
         */
        datePickerOptionsEnd: {
          /**
           * 終了日は開始日より以前を選択できない
           */
          disabledDate: (date) => {
            const str = this.datetimeSet.dateStart;
            const replaced = str.replace(/-/g, ' ,');
            const dateTime = new Date(replaced);
            dateTime.setDate(dateTime.getDate() - 1);
            const condition1 = date.getTime() <= dateTime.getTime();
            return condition1;
          },
        },
      },
    };
  },
  methods: {
    /**
     * 測定日時の開始日、終了日の設定が同じ日付かチェック
     * @returns {boolean}
     */
    $_pickerMixin_checkSameDate() {
      return this.datetimeSet.dateStart === this.datetimeSet.dateEnd;
    },
    /**
     * 開始時刻が現在時刻より過去かチェックする
     * @param {string} startTime - 開始時刻 00:00 - 23:59
     * @returns {boolean}
     */
    $_pickerMixin_checkStartIsPastNow(startTime) {
      const now = new Date();
      /**
       * 現在時刻を 00:00 - 23:59 の文字列に
       * @returns {string}
       */
      const nowStr = now.getHours() + ':' + now.getMinutes();
      return util.getTimeTime(nowStr) < util.getTimeTime(startTime);
    },
  },
  watch: {
    'datetimeSet.timeStart': function (newVal, oldVal) {
      /**
       * 同じ日付の文字列だった場合は処理する
       */
      if (this.$_pickerMixin_checkSameDate()) {
        if (util.getTimeTime(newVal) > util.getTimeTime(this.datetimeSet.timeEnd)) {
          // 開始時刻が終了時刻より遅い場合はエラー
          alert(validateMessage.timeRange);
          this.datetimeSet.timeStart = oldVal;
        } else if (this.$_pickerMixin_checkStartIsPastNow(newVal)) {
          // 開始時刻が現在時刻より未来の場合はエラー
          this.kari = this.$_pickerMixin_checkStartIsPastNow(newVal);
          alert(validateMessage.patStartTime);
          this.datetimeSet.timeStart = oldVal;
        }
      }
    },
    'datetimeSet.timeEnd': function (newVal, oldVal) {
      if (this.$_pickerMixin_checkSameDate()) {
        if (util.getTimeTime(newVal) < util.getTimeTime(this.datetimeSet.timeStart)) {
          alert(validateMessage.timeRange);
          this.datetimeSet.timeEnd = oldVal;
        }
      }
    },
  },
};
